function WhiteButton({ children, onClick }) {
    return (
        <button
            onClick={onClick}
            className="bg-white w-full max-w-full shadow-lg text-black px-7 py-4 md:py-6 rounded-md text-xl font-semibold">
            {children}
        </button>
    )
}

export default WhiteButton
